import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    title: null,
    subTitle: null,
    closable: { type: Boolean, default: true },
    position: { default: 'default' },
    hasHeader: { type: Boolean, default: true },
    hasDoneButton: { type: Boolean },
    disableDoneButton: { type: Boolean },
    onWillDismiss: null
  },
  emits: ["closed", "dismiss"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'closed'): void;
	(e: 'dismiss', data?: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title?: string, subTitle?: string, closable: boolean, position: 'default' | 'bottom', hasHeader: boolean, hasDoneButton?: boolean, disableDoneButton?: boolean, onWillDismiss?: () => Promise<void> };





onMounted(async () => {
	if (props.onWillDismiss != null) {
		await props.onWillDismiss();
		emit('closed');
	}
});

function close() {
	emit('dismiss');
	emit('closed');
}

return { __sfc: true,props, emit, close, BasicButton, faTimes, jwCheckIcon }
}

})